import { reducerFromMap } from './common.reducers';
import { parseUrlParameters, parseArrayParameterValue } from '../libs/helpers';

import {
  COMPRESSORS_LIST,
  COMPRESSORS_LIST_COMPLETE,
  COMPRESSORS_LIST_ERROR,
  ROUTER_LOCATION_CHANGE,
  USERCOMP_LIST,
  USERCOMP_LIST_COMPLETE,
  USERCOMPN_LIST_ERROR,
} from '../actions';

const initialState = {
  loading: false,
  search: '',
  filters: {},
  data: null,
  data2: null,
  message: null,
  filterData: null,
  filterDataLoading: false,
  filterDataMessage: null,
};

const reducerMap = {};

const basicSearchFilters = ['search', 'approved', 'active'];

reducerMap[ROUTER_LOCATION_CHANGE] = (state, action) => {
  if (action.payload.location.pathname !== '/compressors') return state;

  const params = parseUrlParameters(action.payload.location.search);
  const { search } = params;

  const filters = { search };

  Object.keys(params).forEach(key => {
    if (basicSearchFilters.indexOf(key) >= 0) return;
    const val = parseArrayParameterValue(params[key]);
    filters[key] = val;
  });

  return {
    ...state,
    filters,
    message: null,
  };
};

reducerMap[COMPRESSORS_LIST] = (state, action) => ({
  ...state,
  loading: true,
  message: null,
});

reducerMap[COMPRESSORS_LIST_COMPLETE] = (state, action) => ({
  ...state,
  loading: false,
  data: action.data,
});

reducerMap[COMPRESSORS_LIST_ERROR] = (state, action) => ({
  ...state,
  loading: false,
  message: action.error.message,
});

reducerMap[ROUTER_LOCATION_CHANGE] = (state, action) => {
  if (action.payload.location.pathname !== '/userCompressor') return state;
  return {
    ...state,
    // filters,
    message: null,
  };
};

reducerMap[USERCOMP_LIST] = (state, action) => ({
  ...state,
  loading: true,
  message: null,
});

reducerMap[USERCOMP_LIST_COMPLETE] = (state, action) => ({
  ...state,
  loading: false,
  data: action.data2,
});

reducerMap[USERCOMPN_LIST_ERROR] = (state, action) => ({
  ...state,
  loading: false,
  message: action.error.message,
});

export default reducerFromMap(reducerMap, initialState);
